import { render, staticRenderFns } from "./page-linkedin.vue?vue&type=template&id=cb462a58&"
import script from "./page-linkedin.vue?vue&type=script&lang=js&"
export * from "./page-linkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports